'use strict';

import { DSSectionCtrl } from "./dssectionctrl.js";
import { DS1Model } from "../../models/ds1model.js";

export class DS1GeneralCtrl extends DSSectionCtrl {
	end_date_type_1_disabled = false;

	end_date_min;
	end_date_max;

	postConstruct() {
		this.dsModel = new DS1Model(this.jsDataService.get('item', {}), this.$filter, this.jsDataService);
	}

	$onInit() {
		this.startingDateTypeChanged();
		this.startingDateDateChanged();
	}

	modelValue(name) {
		if (typeof(this.dsModel) !== 'undefined') {
			return this.dsModel.getValue(name);
		}
		return '';
	}

	startingDateTypeChanged() {
		if (this.dsModel.starting_date_type != 1) {
			this.end_date_type_1_disabled = true;
			if (this.dsModel.end_date_type == 1) {
				this.dsModel.end_date_type = null;
			}
			this.startingDateDateChanged();
		}
		else {
			this.end_date_type_1_disabled = false;
		}
	}

	startingDateDateChanged() {
		if (this.dsModel.starting_date_type == 2 && !isNaN(this.dsModel.duration)) {
			const newDate = new Date(this.dsModel.obj_starting_date);
			newDate.setMonth(newDate.getMonth() + parseInt(this.dsModel.duration, 10));
			newDate.setDate(1);
			newDate.setUTCHours(12, 0, 0, 0);
			this.end_date_min = new Date(newDate);
			newDate.setMonth(newDate.getMonth() + 1);
			newDate.setDate(newDate.getDate() - 1);
			this.end_date_max = new Date(newDate);
		}
	}

	calculateInterval(startDate, endDate) {
		if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
			throw new Error('Both startDate and endDate must be valid Date objects.');
		}

		let years = endDate.getUTCFullYear() - startDate.getUTCFullYear();
		let months = endDate.getUTCMonth() - startDate.getUTCMonth();
		let days = endDate.getUTCDate() - startDate.getUTCDate();

		if (days < 0) {
			// Borrow days from the previous month
			months -= 1;
			const previousMonth = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), 0);
			days += previousMonth.getUTCDate();
		}

		if (months < 0) {
			years -= 1;
			months += 12;
		}

		const totalMonths = years * 12 + months;

		return {
			months: totalMonths,
			days: days
		};
	}

	normalizeDate(dateObj) {
		if (!(dateObj instanceof Date) || isNaN(dateObj)) {
			return null;
		}
		const normalizedDate = new Date(dateObj);
		normalizedDate.setUTCHours(12, 0, 0, 0);
		return normalizedDate;
	}

	badInterval() {
		if (
			this.dsModel.starting_date_type == 2 &&
			this.dsModel.end_date_type == 2 &&
			!isNaN(this.dsModel.duration)
		) {
			let startDate = this.dsModel.obj_starting_date;
			let endDate = this.dsModel.obj_end_date;
			const durationMonths = parseInt(this.dsModel.duration, 10);

			if (!startDate || !endDate) {
				return true;
			}

			startDate = this.normalizeDate(startDate);
			endDate = this.normalizeDate(endDate);

			const interval = this.calculateInterval(startDate, endDate);

			if (interval.months !== durationMonths || interval.days !== 0) {
				return true;
			}
		}
		return false;
	}

	getMonthDiff(startDate, endDate) {
		const startYear = startDate.getUTCFullYear();
		const startMonth = startDate.getUTCMonth();
		const startDay = startDate.getUTCDate();
		const endYear = endDate.getUTCFullYear();
		const endMonth = endDate.getUTCMonth();
		const endDay = endDate.getUTCDate();

		const yearDifference = endYear - startYear;
		const monthDifference = endMonth - startMonth;
		const totalMonths = yearDifference * 12 + monthDifference;

		if (endDay < startDay) {
			return totalMonths - 1;
		}

		return totalMonths;
	}

	autosavePostFields() {
		return {
			dsmodel: {
				consortium_agreement: this.dsModel.consortium_agreement,
				starting_date_type: this.dsModel.starting_date_type,
				end_date_type: this.dsModel.end_date_type,
				starting_date_date: (this.dsModel.starting_date_type == 2)
					? this.$filter('date')(this.dsModel.obj_starting_date, 'yyyy-MM-dd')
					: '',
				end_date_date: (this.dsModel.end_date_type == 2)
					? this.$filter('date')(this.dsModel.obj_end_date, 'yyyy-MM-dd')
					: '',
			},
		};
	}
}
